module.exports = __webpack_public_path__ + "img/eduardo-main-384x384.2e78c40d.jpg";